<template>
    <div id="row" class="d-flex flex-column align-items-left">
      <div class="row1 d-flex flex-rows justify-content-between align-items-center">
        <div class="lg1">
          <span class="category">{{category.lg1}}</span> <span class="type">{{type.lg1}}</span>
        </div>
        <div class="price float-right">{{price}}</div>
      </div>
      <div class="row2 lg2">
        <span class="category">{{category.lg2}}</span > <span class="type">{{type.lg2}}</span>
      </div>
    </div>
</template>

<script>
export default {
  name: 'MercureRatesHorizontalV1RatesRow',
  props: {
    ratesLg1: Object,
    ratesLg2: Object
  },
  computed: {
    category () {
      return {lg1: this.ratesLg1.catroom_label, lg2: this.ratesLg2.catroom_label}
    },
    type () {
      return {lg1: this.ratesLg1.label_value, lg2: this.ratesLg2.label_value}
    },
    price () {
      return this.ratesLg1.mrr_value
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_mercure.scss";

#row {
  width: 100%;
  @include heightPercent(120);
  border-top: 1px solid $purple;

  .row1 {
    margin-top: 0.3vh;

    .lg1 {
      max-height: 2rem;
      overflow: hidden;

      .category {
        font-family: "HouschkaAltPro-DemiBold";
        text-transform: uppercase;
        @include fontSize(35);
      }

      .type {
        font-family: "HouschkaAltPro-Medium";
        @include fontSize(35);
      }
    }

    .price {
      font-family: "HouschkaAltPro-DemiBold";
      @include fontSize(42);
      color: $purple;
      white-space: nowrap;
    }
  }

  .row2 {
    //margin-top: 0.5vh;
    max-height: 1.5rem;
    overflow: hidden;

    .category { 
      font-family: "HouschkaAltPro-DemiBold";
      text-transform: uppercase;
      @include fontSize(29);
    }

    .type {
      font-family: "HouschkaAltPro-Medium";
      @include fontSize(29);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mercure/rates/horizontal/v1/rates/rowRates.vue